import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, Card, Center, Heading, Spinner, Text, VStack } from 'wss3-forge'
import { clearPkce, exchangeCode, readPkceVerifier } from '../lib/webba-bridge.js'
import { useAuth } from '../contexts/AuthContext.js'

const RETURN_URL_KEY = 'webba_return_url'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const { setSession } = useAuth()
  const [error, setError] = useState<string | null>(null)
  const ranRef = useRef(false)

  useEffect(() => {
    if (ranRef.current) return
    ranRef.current = true

    const run = async () => {
      const params = new URLSearchParams(window.location.search)
      const errorParam = params.get('error')
      if (errorParam) {
        setError(params.get('error_description') ?? errorParam)
        return
      }
      const code = params.get('code')
      const state = params.get('state')
      if (!code || !state) {
        setError('Paramètres OAuth manquants (code/state).')
        return
      }

      const codeVerifier = readPkceVerifier(state)
      if (!codeVerifier) {
        setError('Code PKCE introuvable. Recommence le login.')
        return
      }

      try {
        const session = await exchangeCode(code, codeVerifier)
        clearPkce(state)
        setSession(session)

        window.history.replaceState({}, '', window.location.pathname)

        const returnTo = sessionStorage.getItem(RETURN_URL_KEY) ?? '/'
        sessionStorage.removeItem(RETURN_URL_KEY)
        navigate(returnTo, { replace: true })
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Authentification échouée')
        ranRef.current = false
      }
    }

    void run()
  }, [navigate, setSession])

  if (error) {
    return (
      <Center style={{ minHeight: '100dvh', padding: 'var(--spacing-md)' }}>
        <Card padding="xl" variant="elevated" style={{ width: '100%', maxWidth: 420 }}>
          <VStack gap="md" align="center">
            <Heading level={3}>Connexion échouée</Heading>
            <Text color="muted" align="center">
              {error}
            </Text>
            <Button variant="primary" onClick={() => navigate('/login', { replace: true })}>
              Retour
            </Button>
          </VStack>
        </Card>
      </Center>
    )
  }

  return (
    <Center style={{ minHeight: '100dvh' }}>
      <VStack gap="md" align="center">
        <Spinner size="lg" />
        <Text color="muted">Connexion en cours…</Text>
      </VStack>
    </Center>
  )
}
